import _ from 'lodash';

export default function lsMoneyFilter(value) {
    let twoDecimalNumber = _.toNumber(value).toFixed(2);
    if (twoDecimalNumber % 1 === 0) {
        twoDecimalNumber = parseInt(twoDecimalNumber, 10);
    }
    return `$${twoDecimalNumber}`;
}
